export default abstract class CartingRequest {
  public abstract toJSON(): any;
}
